/**
 * Brazilian Portuguese (pt-BR) mappings for SportsHub
 */

export const sportsHubPtBR = {
  // Main title and subtitle
  "PickStar": "PickStar",
  "Data Hub": "Central de Dados",
  "Access live sports data, comprehensive statistics, and real-time updates across multiple sports. Your complete resource for data-driven sports analysis.": 
    "Acesse dados esportivos ao vivo, estatísticas abrangentes e atualizações em tempo real de vários esportes. Seu recurso completo para análise esportiva baseada em dados.",
  "Access live sports data and get instant AI picks directly on games. View comprehensive statistics, real-time updates, and AI-powered betting recommendations across multiple sports.":
    "Acesse dados esportivos ao vivo e obtenha previsões de IA instantâneas diretamente nos jogos. Veja estatísticas abrangentes, atualizações em tempo real e recomendações de apostas com IA em vários esportes.",
  
  // Beta notice - Including mobile condensed version
  "Beta • More Coming Soon": "Beta • Mais em Breve",
  "Beta v3": "Beta v3",
  "v3 Beta Preview • Limited features available • Full sports coverage expanding soon": 
    "Prévia Beta v3 • Recursos limitados disponíveis • Cobertura esportiva completa em expansão",
  
  // Stats cards - Updated for new compact mobile design
  "Live": "Ao Vivo",
  "Stats": "Estatísticas",
  "Sports": "Esportes",
  "Live Data": "Dados ao Vivo",
  "Real-time updates": "Atualizações em tempo real",
  "24/7": "24/7",
  "Analytics": "Análises",
  "Detailed statistics": "Estatísticas detalhadas",
  "1M+": "1M+",
  "6+": "6+",
  "Multi-Sport": "Multi-Esportes",
  "6+ Sports covered": "6+ Esportes cobertos",
  "Global": "Global",
  
  // Dashboard cards
  "Football": "Futebol",
  "Soccer": "Futebol",
  "Live fixtures, standings, and player statistics from top leagues worldwide.": 
    "Partidas ao vivo, classificações e estatísticas de jogadores das principais ligas do mundo.",
  "Premier League": "Premier League",
  "La Liga": "La Liga",
  "Champions League": "Liga dos Campeões",
  "Live Scores": "Placares ao Vivo",
  "matches": "partidas",
  "players": "jogadores",
  
  "MLB + International": "MLB + Internacional",
  "Baseball": "Beisebol",
  "Live games, standings, EV calculator, and comprehensive baseball statistics.":
    "Jogos ao vivo, classificações, calculadora EV e estatísticas completas de beisebol.",
  "Standings": "Classificações",
  "EV Calculator": "Calculadora EV",
  "Real Odds Data": "Dados de Odds Reais",
  "leagues": "ligas",
  "teams": "times",
  
  "MMA Fights": "Lutas de MMA",
  "Mixed Martial Arts": "Artes Marciais Mistas",
  "Fight schedules, fighter stats, and real-time match updates.":
    "Calendário de lutas, estatísticas de lutadores e atualizações de combates em tempo real.",
  "UFC Events": "Eventos UFC",
  "Fighter Stats": "Estatísticas de Lutadores",
  "Fight Results": "Resultados de Lutas",
  "Live Updates": "Atualizações ao Vivo",
  "events": "eventos",
  "fighters": "lutadores",
  
  "NFL": "NFL",
  "American Football": "Futebol Americano",
  "American Football games, team standings, and player statistics.":
    "Jogos de futebol americano, classificações de times e estatísticas de jogadores.",
  "Game Schedules": "Calendário de Jogos",
  "Team Stats": "Estatísticas de Times",
  "Player Rosters": "Elencos",
  
  "NCAAF": "NCAAF",
  "College Football": "Futebol Universitário",
  "American College Football games, team standings, and player statistics.":
    "Jogos de futebol universitário americano, classificações de times e estatísticas de jogadores.",
  "conferences": "conferências",
  "10": "10",
  
  "Volleyball": "Vôlei",
  "International Leagues": "Ligas Internacionais",
  "International volleyball matches, league tables, and team information.":
    "Partidas internacionais de vôlei, tabelas de ligas e informações de times.",
  "Live Matches": "Partidas ao Vivo",
  "League Tables": "Tabelas de Liga",
  "Tournaments": "Torneios",
  
  // Status badges
  "Active": "Ativo",
  "Coming Soon": "Em Breve",
  
  // Action buttons
  "View Dashboard": "Ver Painel",
  "Preview Dashboard": "Prévia do Painel",
  
  // Coming soon section
  "More Sports Coming Soon": "Mais Esportes em Breve",
  "We're constantly expanding our coverage. Basketball, hockey, tennis, and more advanced analytics features are on the way. Stay tuned for updates!":
    "Estamos constantemente expandindo nossa cobertura. Basquete, hóquei, tênis e recursos de análise mais avançados estão a caminho. Fique atento às novidades!",
  "Get Pro Access": "Obter Acesso Pro",
  "Ask AI Assistant": "Consultar Assistente IA",
  
  // Additional UI elements and stats
  "2.5K+": "2.5K+",
  "50K+": "50K+",
  "77+": "77+",
  "600+": "600+",
  "300+": "300+",
  "5K+": "5K+",
  "32": "32",
  "1.7K+": "1.7K+",
  "130+": "130+",
  "10": "10",
  "20+": "20+",
  "500+": "500+",
  
  // NBA
  "NBA": "NBA",
  "Basketball": "Basquete",
  "National Basketball Association games, standings, and player statistics.":
    "Jogos da NBA, classificações e estatísticas de jogadores.",
  "Live Games": "Jogos ao Vivo",
  "Player Stats": "Estatísticas de Jogadores",
  "Team Standings": "Classificação dos Times",
  "Playoffs": "Playoffs",
  "30": "30",
  "450+": "450+",
  
  // WNBA
  "WNBA": "WNBA",
  "Women's Basketball": "Basquete Feminino",
  "Women's National Basketball Association games and statistics.":
    "Jogos e estatísticas da WNBA.",
  "Championships": "Campeonatos",
  "12": "12",
  "144+": "144+",
  
  // NHL
  "NHL": "NHL",
  "Hockey": "Hóquei",
  "National Hockey League games, standings, and player statistics.":
    "Jogos da NHL, classificações e estatísticas de jogadores.",
  "Stanley Cup": "Stanley Cup",
  "700+": "700+",
  
  // Status
  "LIVE": "AO VIVO",
  "SOON": "EM BREVE",
  
  // Tap hint
  "Tap to explore": "Toque para explorar",
  
  // Mobile header
  "Sports Hub": "Central de Esportes",
  "All sports data": "Todos os dados esportivos",

  // QuickPicks Hub - New translations
  "The Pick Lab": "O Laboratório de Picks",
  "Research Data Hub & QuickPickZone": "Central de Dados de Pesquisa & QuickPickZone",
  "QUICKPICKS HUB": "CENTRAL DE QUICKPICKS",
  "QuickPicks": "QuickPicks",
  "Access every game - live or future. View standings, league fixtures, and player data.": "Acesse todos os jogos - ao vivo ou futuros. Veja classificações, tabelas de liga e dados de jogadores.",
  "QuickPicks provide AI confidence ratings for straight bets. Enhanced insights coming soon for maximum speed-to-decision.": "QuickPicks fornecem classificações de confiança da IA para apostas diretas. Insights aprimorados em breve para máxima velocidade de decisão.",
  "See community consensus": "Ver consenso da comunidade",
  "Instant AI picks for all games": "Escolhas instantâneas de IA para todos os jogos",
  "AI picks for all games": "Escolhas de IA para todos os jogos",
  "Select your sport below to access QuickPicks": "Selecione seu esporte abaixo para acessar QuickPicks",
  "SELECT SPORT FOR DATA & QUICKPICKS": "SELECIONE ESPORTE PARA DADOS & QUICKPICKS",
  "SELECT SPORT FOR QUICKPICKS": "SELECIONE ESPORTE PARA QUICKPICKS",
  "ACCESS QUICKPICKS": "ACESSAR QUICKPICKS",
  "ONLY AI CHAT MODE": "APENAS MODO CHAT IA",
  "Only AI Chat mode": "Apenas Chat IA",
  "V3 BETA • LIMITED FEATURES • EXPANDING SOON": "V3 BETA • RECURSOS LIMITADOS • EXPANDINDO EM BREVE",
  "MORE SPORTS COMING SOON": "MAIS ESPORTES EM BREVE",
  "We're constantly expanding our coverage. Basketball, hockey, tennis, and more advanced analytics features are on the way.": "Estamos constantemente expandindo nossa cobertura. Basquete, hóquei, tênis e recursos de análise mais avançados estão a caminho.",
  "GET PRO ACCESS": "OBTER ACESSO PRO",
  "ASK AI": "PERGUNTAR IA"
};